import { object, string, null as zNull } from "zod";

export const retryItemReceiptEvent = {
  name: "retryItemReceiptEvent" as const,
  input: object({ returnId: string(), itemReceiptId: string() }),
  output: zNull(),
};
